import { render, staticRenderFns } from "./CreateDriver.vue?vue&type=template&id=2d7a6de8&"
import script from "./CreateDriver.vue?vue&type=script&lang=js&"
export * from "./CreateDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports